import React, { useState } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  Label,
  Input,
} from "reactstrap";
import { useUpdateProductTransferStatus } from "hooks/useProductTransfer";
import { BaseButton } from "Components";

const UpdateProductTransferStatus = ({ isOpen, toggle, editDetails }) => {
  const [status, setStatus] = useState(editDetails?.status);
  const { mutate: updateStatus, isPending } = useUpdateProductTransferStatus();

  if (!editDetails) {
    return null;
  }

  const handleSubmit = () => {
    editDetails.status = status || editDetails.status;
    const payload = {
      id: editDetails.id,
      status: editDetails.status,
    };
    updateStatus(
      { id: payload.id, data: payload },
      {
        onSuccess: () => {
          toggle();
          resetForm();
        },
      }
    );
  };

  const handleCancel = () => {
    setStatus("");
    toggle();
  };

  const resetForm = () => {
    setStatus("");
  };

  return (
    <Modal isOpen={isOpen} toggle={handleCancel} centered>
      <ModalHeader toggle={handleCancel}>
        Update Product Transfer Status
      </ModalHeader>
      <ModalBody>
        <FormGroup>
          <Label for="product_transfer_status">Status</Label>
          <Input
            id="product_transfer_status"
            name="product_transfer_status"
            value={status || editDetails.status}
            type="select"
            onChange={(e) => setStatus(e.target.value)}
            placeholder="Select status"
            required
          >
            {editDetails.status !== "approved" && (
              <option value="draft" key="1">
                Draft
              </option>
            )}
            <option value="in review" key="2">
              In review
            </option>
            {editDetails.status !== "draft" && (
              <option value="approved" key="3">
                Approved
              </option>
            )}
          </Input>
        </FormGroup>
      </ModalBody>
      <ModalFooter>
        <BaseButton
          color="primary"
          onClick={handleSubmit}
          loading={isPending}
          disabled={isPending}
        >
          Update
        </BaseButton>
        <BaseButton color="secondary" onClick={handleCancel}>
          Cancel
        </BaseButton>
      </ModalFooter>
    </Modal>
  );
};

export default UpdateProductTransferStatus;
